import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import debounce from 'lodash/debounce';
import { ReactComponent as SearchIcon } from '../../../../assets/img/icons/common/Search.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/img/icons/common/Close.svg';
import { changeActivityHistorySearch } from '../../../../redux/actions/kitchenPlayerAction';
import { changeKHPSeveralValues } from '../../../../redux/actions/kitchenHistoryPlayerAction';
import '../../../../components/Search/PageSearch/PageSearch.scss';
import '../../styles/Search.scss';

const Search = ({ historyMode }) => {
  const [opened, setOpened] = useState(false);
  const [focused, setFocused] = useState(false);
  
  const historyModeRef = useRef(historyMode);
  historyModeRef.current = historyMode;
  
  const dispatch = useDispatch();
  const search = useSelector(state => state.kitchenPlayer.activityHistory.search);

  const setSearch = newSearch => {
    dispatch(changeActivityHistorySearch(newSearch));

    if (historyModeRef.current) {
      dispatch(
        changeKHPSeveralValues({
          pollingStartDate: null,
          pollingEndDate: null,
        })
      );
    }
  };

  const debouncedOnChange = useMemo(() => {
    return debounce(event => setSearch(event.target.value), 300);
  }, []);

  const onClose = () => {
    debouncedOnChange.cancel();
    setSearch(null);
  };

  useEffect(() => {
    return () => debouncedOnChange.cancel();
  }, []);

  return (
    <div
      className={cx('page-search__container khp-search', {
        closed: !opened,
        focused,
        ['has-value']: !!search && !opened,
      })}
      onClick={() => setOpened(true)}
    >
      <SearchIcon />

      {opened ? (
        <>
          <input
            className="page-search__input"
            type="text"
            defaultValue={search}
            placeholder="Search"
            maxLength={255}
            onChange={debouncedOnChange}
            autoFocus
            onFocus={() => setFocused(true)}
            onBlur={() => {
              setFocused(false);
              setOpened(false);
            }}
          />

          <button className="page-search__close-btn" disabled={!search} onMouseDown={onClose}>
            <CloseIcon />
          </button>
        </>
      ) : null}
    </div>
  );
};

export default Search;
